let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k0Mrq")).then(() => parcelRequire('1d4Fe'));